import type { TrackingConnectionResult } from '@chukua/common';
import { Alert } from 'antd';

export function ConnectionResultAlert({ result }: { result: TrackingConnectionResult }) {
  if (result.ok) return <Alert type="success" showIcon title="Connected. The vendor accepted these credentials." />;
  return <Alert type="error" showIcon title="Could not connect" description={result.reason} />;
}
